module.exports = __webpack_public_path__ + "static/media/51-iveco.73aa6e2c.jpg";